export interface UserCriteria {
  keyword: string
  taskType: string
  freeze: string
  expired: string
  deleted: string
}

export function userSearchParams(criteria: UserCriteria, current: number, size: number) {
  const params = new URLSearchParams({ current: String(current), size: String(size) })
  const keyword = criteria.keyword.trim()
  if (keyword) params.set('keyword', keyword)
  for (const key of ['taskType', 'freeze', 'expired', 'deleted'] as const) {
    if (criteria[key] && criteria[key] !== 'all') params.set(key, criteria[key])
  }
  return params
}

export interface SelectionAccount { id: number; delete: number; name?: string; account?: string }
interface SearchPage<T> {
  code: number
  msg?: string
  data?: { current: number; page: number; total: number; records: T[] }
}

// Commit no partial result: stale/cancelled, failed or shifting pagination must be retried.
export async function fetchMatchingUsers<T extends SelectionAccount>(
  criteria: UserCriteria,
  request: (url: string) => Promise<SearchPage<T>>,
  signal: AbortSignal,
): Promise<T[]> {
  const seen = new Set<number>()
  const accounts: T[] = []
  let total: number | undefined
  let pages: number | undefined
  for (let current = 1; ; current++) {
    signal.throwIfAborted()
    const result = await request(`/searchAccount?${userSearchParams(criteria, current, 100)}`)
    signal.throwIfAborted()
    const data = result.data
    if (result.code !== 200 || !data) throw new Error(result.msg || '获取完整用户清单失败')
    if (!Number.isSafeInteger(data.total) || data.total < 0 || !Number.isSafeInteger(data.page) || data.page < 0 || data.current !== current || !Array.isArray(data.records)) {
      throw new Error('用户分页信息异常，请刷新后重试')
    }
    total ??= data.total
    pages ??= data.page
    if (total !== data.total || pages !== data.page) throw new Error('用户列表已变化，请重新全选')
    for (const user of data.records) {
      if (!Number.isSafeInteger(user.id) || seen.has(user.id)) throw new Error('用户列表已变化，请重新全选')
      seen.add(user.id)
      if (user.delete !== 1) accounts.push(user)
    }
    if (current >= pages) {
      if (seen.size !== total) throw new Error('用户清单不完整，请重新全选')
      return accounts
    }
    if (data.records.length === 0 || seen.size >= total) throw new Error('用户分页信息异常，请重新全选')
  }
}
